import React from 'react';
import { useHistory } from 'react-router';

import { Box } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircle';

import { AssessmentSelectorGraphQL } from '../../../Assessment/AssessmentSelector/assessment-selector.graphql';
import { hasAnyRoles } from '../../../../lib/services/user.service';
import { ROLES } from '../../../../../_configuration';
import { mainColor } from '../../../../lib/theme';

export const AssessmentSelectorLayout = ({requiredRoles}: {requiredRoles?: string[]}) => {
    const hasConfigRole = hasAnyRoles({roles: [ROLES.CONFIGURATION]});
    const history = useHistory();

    return (
      <>
        <Box flexGrow={1} mr={1}>
          <AssessmentSelectorGraphQL requiredRoles={requiredRoles} />
        </Box>
        {
          hasConfigRole &&
          <IconButton onClick={() => history.push('/assessments/create')}>
            <AddIcon style={{ color: mainColor }} />
          </IconButton>
        }
      </>
    )
}